import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  Row,
  Select,
} from "antd";

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import AttachmentsUpload from "../../../../../components/common/AttachmentsUpload";
import FormAction from "../../../../../components/common/FormAction";
import Notes from "../../../../../components/common/Notes";
import PageHeading from "../../../../../components/common/PageHeading";
import RightBarMethod from "../../../../../components/common/RightBar/RightBarMethod";
import RightBar from "../../../../../components/common/RightBar";

import {
  recurringBills as recurringBillsData,
  selectData,
  tenants,
} from "../../../../../data/accounting";

import { FaRegEdit } from "react-icons/fa";
import { MdRemoveCircle, MdAddCircle } from "react-icons/md";

import "./RecurringBillDetails.css";
import History from "../../../../../components/common/History";

function RecurringBillDetails() {
  const [checked, setChecked] = useState(false);
  const [recurringBillDetails, setRecurringBillDetails] = useState({});
  const [recurringBills, setRecurringBills] = useState([
    {
      property: "",
      unit: "",
      account: "",
      description: "",
      amount: "",
    },
  ]);

  const addAnotherRecurringBills = () => {
    setRecurringBills([
      ...recurringBills,
      {
        startDate: "",
        endDate: "",
        description: "",
        glAccount: "",
        amount: "",
      },
    ]);
  };

  const onRemoveRecurringBills = (index) => {
    const newRecurringBills = [...recurringBills];
    newRecurringBills.splice(index, 1);
    setRecurringBills(newRecurringBills);
  };

  const { id } = useParams();

  useEffect(() => {
    const newObject = recurringBillsData.find((item) => {
      return item.id === Number(id);
    });
    setRecurringBillDetails(newObject);
  }, []);

  const onCancel = () => {
    setChecked(false);
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenPostBill, setIsModalOpenPostBill] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
    setIsModalOpenPostBill(false)
  };
  const handleCancel = () => {
    setIsModalOpen(false);
    setIsModalOpenPostBill(false)

  };
  const showPostBillModal = () => {
    setIsModalOpenPostBill(true);
  };

  const RecurringBillDetailsRightBar = [
    RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
      RightBarMethod(
        "Enter Bill",
        "1",
        "",
        "",
        "/accounting/payables_bills/bills/enter-bils"
      ),
      RightBarMethod("Automated AP", "2", "", "", ""),
      RightBarMethod(
        "Smart Bill Entry",
        "3",
        "",
        "",
        "/accounting/payables_bills/bills/smartbillentry"
      ),
      RightBarMethod(
        "Enter Utility Bill (RUBS)",
        "5",
        "",
        "",
        "/accounting/payables_bills/bills/utility-bill-details"
      ),
      RightBarMethod("Enter Credit", "6", "", "", ""),
      RightBarMethod(
        "Pay Bills",
        "7",
        "",
        "",
        "/accounting/payables_bills/paybills"
      ),
      RightBarMethod(
        "Tenant Payable",
        "8",
        "",
        "",
        "/accounting/payables_bills/bills/newtenantpayable"
      ),
      RightBarMethod(
        "New Recurring Bill",
        "9",
        "",
        "",
        "/accounting/payables_bills/recurring_invoices/newrecurringbill"
      ),
      RightBarMethod(
        "Manually Post Bills",
        "10",
        "",
        "",
        "/accounting/payables_bills/recurring_invoices/manually_post_bills"
      ),
      RightBarMethod(
        "Upload Bulk Bills",
        "11",
        "",
        "",
        "/accounting/payables_bills/bills/upload-bulk-bills"
      ),
      RightBarMethod(<a onClick={showPostBillModal}>Post Bill Now</a>, "12", "", "", ""),
      RightBarMethod(<a onClick={showModal}>Delete Bill</a>, "13", "", "", ""),
    ]),
  ];
  return (
    <>
      <div className="recurring-bill-details">
        {!checked ? (
          <Row gutter={[8, 0]} justify="end">
            <Col>
              <button
                className="icon-btn-container"
                onClick={() => setChecked(true)}
              >
                <FaRegEdit size={16} />
                <span>Edit</span>
              </button>
            </Col>
          </Row>
        ) : null}
        <PageHeading heading="Recurring Bill Details" />
        <Form
          colon={false}
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 11 }}
          labelWrap={{ span: 8 }}
          className="form-rows"
        >
          {checked ? (
            <Row gutter={[0, 24]}>
              <Col span={24}>
                <Card>
                  <Row>
                    <Col span={12}>
                      <Form.Item label="Payee">
                        <Select
                          options={tenants}
                          placeholder="Select..."
                          showSearch
                          allowClear
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                      <Form.Item label="Start Date" required>
                        <DatePicker style={{ width: "100%" }} />
                      </Form.Item>
                      <Form.Item label="Bill Day" required>
                        <Input />
                      </Form.Item>
                      <Form.Item label="Remarks">
                        <Input />
                      </Form.Item>
                      <Form.Item label="Memo on Check">
                        <Input />
                      </Form.Item>
                      <Form.Item label="Repeats">
                        <Select
                          options={[
                            { value: "Never (Must Post Manually)" },
                            { value: "Monthly" },
                          ]}
                          defaultValue="Never (Must Post Manually)"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item label=" Total Amount" required>
                        <Input />
                      </Form.Item>
                      <Form.Item label="End Date">
                        <DatePicker style={{ width: "100%" }} />
                      </Form.Item>
                      <Form.Item label="Due Day" required>
                        <Input />
                      </Form.Item>
                      <Form.Item label="Post Code">
                        <Input />
                      </Form.Item>
                    </Col>
                  </Row>
                </Card>
              </Col>
              <Col span={24}>
                <Card>
                  <div className="row-container">
                    <Row>
                      <Col span={4} className="header-row">
                        <span>Properties</span>
                      </Col>
                      <Col span={5} className="header-row">
                        <span>Unit</span>
                      </Col>
                      <Col span={5} className="header-row">
                        <span>Account</span>
                      </Col>
                      <Col span={6} className="header-row">
                        <span>Description</span>
                      </Col>
                      <Col span={2} className="header-row">
                        <span>Amount </span>
                      </Col>
                    </Row>
                    {recurringBills.map((item, index) => {
                      return (
                        <Row align="middle" gutter={[8, 0]} key={index}>
                          <Col span={4}>
                            <Select
                              options={selectData}
                              placeholder="Select..."
                              style={{ width: "100%" }}
                            />
                          </Col>
                          <Col span={5}>
                            <Select
                              options={selectData}
                              placeholder="Select..."
                              style={{ width: "100%" }}
                            />
                          </Col>
                          <Col span={5}>
                            <Select
                              options={selectData}
                              placeholder="Select..."
                              style={{ width: "100%" }}
                            />
                          </Col>
                          <Col span={6}>
                            <Input />
                          </Col>
                          <Col span={2}>
                            <Input />
                          </Col>
                          <Col span={1}>
                            <MdAddCircle
                              style={{ color: "#008a00" }}
                              size={20}
                              onClick={() => addAnotherRecurringBills()}
                            />
                          </Col>
                          {recurringBills.length > 1 ? (
                            <Col span={1}>
                              <MdRemoveCircle
                                style={{ color: "#de1414" }}
                                size={20}
                                onClick={() => onRemoveRecurringBills(index)}
                              />
                            </Col>
                          ) : null}
                        </Row>
                      );
                    })}
                  </div>
                </Card>
              </Col>
              <Col span={24}>
                <FormAction cancel={onCancel} />
              </Col>
            </Row>
          ) : (
            <Row gutter={[0, 24]}>
              <Col span={24}>
                <Card>
                  <Row>
                    <Col span={12}>
                      <Form.Item label="Payee">
                        <p>{recurringBillDetails?.payee}</p>
                      </Form.Item>
                      <Form.Item label="Start Date">
                        <p>{recurringBillDetails?.startDate}</p>
                      </Form.Item>
                      <Form.Item label="Bill Day">
                        <p>{recurringBillDetails?.billDay}</p>
                      </Form.Item>
                      <Form.Item label="Remarks">
                        <p>{recurringBillDetails?.remarks}</p>
                      </Form.Item>
                      <Form.Item label="Memo on Check">
                        <p>{recurringBillDetails?.memoOnCheck}</p>
                      </Form.Item>
                      <Form.Item label="Repeats">
                        <p>{recurringBillDetails?.repeats}</p>
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item label=" Total Amount">
                        <p>{recurringBillDetails?.amount}</p>
                      </Form.Item>
                      <Form.Item label="End Date">
                        <p>{recurringBillDetails?.endDate}</p>
                      </Form.Item>
                      <Form.Item label="Due Day">
                        <p>{recurringBillDetails?.dueDay}</p>
                      </Form.Item>
                      <Form.Item label="Post Code">
                        <p>{recurringBillDetails?.postCode}</p>
                      </Form.Item>
                    </Col>
                  </Row>
                  <p>This bill doesn't automatically recur.</p>
                </Card>
              </Col>
              <Col span={24}>
                <Card>
                  <Row className="header-row">
                    <Col span={8}>
                      <span>Properties</span>
                    </Col>
                    <Col span={2}>
                      <span>Unit</span>
                    </Col>
                    <Col span={6}>
                      <span>Account</span>
                    </Col>
                    <Col span={6}>
                      <span>Description</span>
                    </Col>
                    <Col span={2}>
                      <span>Amount </span>
                    </Col>
                  </Row>
                  {recurringBillDetails?.recurringBills
                    ? recurringBillDetails.recurringBills.map((item, index) => {
                        return (
                          <Row align="middle" key={index} className="data-row">
                            <Col span={8}>
                              <p>{item.property}</p>
                            </Col>
                            <Col span={2}>
                              <p>{item.unit}</p>
                            </Col>
                            <Col span={6}>
                              <p>{item.account}</p>
                            </Col>
                            <Col span={6}>
                              <p>{item.description}</p>
                            </Col>
                            <Col span={2}>
                              <p>{item.amount}</p>
                            </Col>
                          </Row>
                        );
                      })
                    : null}
                </Card>
              </Col>
              <Col span={24}>
                <Card
                  title={`Recently Posted Bills ${
                    recurringBillDetails?.recentlyPostedBills
                      ? recurringBillDetails.recentlyPostedBills.length
                      : null
                  } / ${
                    recurringBillDetails?.recentlyPostedBills
                      ? recurringBillDetails.recentlyPostedBills.length
                      : null
                  }`}
                >
                  <Row className="header-row">
                    <Col span={8}>
                      <span>Bill Date</span>
                    </Col>
                    <Col span={8}>
                      <span>Due Date</span>
                    </Col>
                    <Col span={4}>
                      <span>Amount</span>
                    </Col>
                    <Col span={4}>
                      <span>Status</span>
                    </Col>
                  </Row>
                  {recurringBillDetails?.recentlyPostedBills
                    ? recurringBillDetails.recentlyPostedBills.map(
                        (item, index) => {
                          return (
                            <Row
                              align="middle"
                              key={index}
                              className="data-row"
                            >
                              <Col span={8}>
                                <p>{item.billDate}</p>
                              </Col>
                              <Col span={8}>
                                <p>{item.dueDate}</p>
                              </Col>
                              <Col span={4}>
                                <p>{item.amount}</p>
                              </Col>
                              <Col span={4}>
                                <p>{item.status}</p>
                              </Col>
                            </Row>
                          );
                        }
                      )
                    : null}
                </Card>
              </Col>
            </Row>
          )}
          <Row gutter={[0, 24]}>
            <Col span={24}>
              <History />
            </Col>
            <Col span={24}>
              {/* <Notes /> */}
            </Col>
            <Col span={24}>
              {/* <AttachmentsUpload /> */}
            </Col>
          </Row>
        </Form>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={RecurringBillDetailsRightBar} />
      </div>

      <Modal
        title="Please Confirm"
        centered
        open={isModalOpen}
        footer={
          <div style={{ display: "flex", justifyContent: "start" }}>
            <Button type="primary" onClick={handleOk}>
              Ok
            </Button>
            <Button onClick={handleCancel}>Cancel</Button>

          </div>
        }
      >
        <p>Do you want to delete this recurring bill?</p>
      </Modal>

      <Modal
        title="Post Bill Now"
        centered
        open={isModalOpenPostBill}
        footer={
          <div style={{ display: "flex", justifyContent: "start" }}>
            <Button type="primary" onClick={handleOk}>
              Ok
            </Button>
            <Button onClick={handleCancel}>Cancel</Button>

          </div>
        }
      >
        <p>Do you want to post this bill for test test now?</p>
      </Modal>
    </>
  );
}

export default RecurringBillDetails;
